var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-main-right"},_vm._l((_vm.conf),function(item,index){return _c(item,{key:index,ref:item,refInFor:true,tag:"component",staticClass:"box"})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }